if (!customElements.get('bundle-tier-bar')) {
  customElements.define('bundle-tier-bar', class BundleTierBar extends HTMLElement {
    constructor() {
      super();
      this.helpButton = this.querySelector('.announcement-bar-bundle__help');
      this.tooltip = this.querySelector('.announcement-bar-bundle__tooltip');
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onHelpClick = this.onHelpClick.bind(this);
    }
    connectedCallback() {
      if (!this.helpButton || !this.tooltip) return;
      this.helpButton.addEventListener('click', this.onHelpClick);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
    }
    disconnectedCallback() {
      if (this.helpButton) this.helpButton.removeEventListener('click', this.onHelpClick);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }
    onHelpClick(event) {
      event.stopPropagation();
      this.toggle();
    }
    isOpen() {
      return this.helpButton.getAttribute('aria-expanded') === 'true';
    }
    open() {
      this.helpButton.setAttribute('aria-expanded', 'true');
      this.tooltip.removeAttribute('hidden');
    }
    close() {
      this.helpButton.setAttribute('aria-expanded', 'false');
      this.tooltip.setAttribute('hidden', '');
    }
    toggle() {
      this.isOpen() ? this.close() : this.open();
    }
    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }
    onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen()) {
        this.close();
        this.helpButton.focus();
      }
    }
  });
}
